import React, { useState } from 'react';
import { postAnulacionReversionOrdenApi } from "../../../api/axios";
import ModalItem from "../../General/Modal";
import { toast } from "react-toastify";

export default function AnulacionReversion({
  idOrden,
  idSeller,
  motivosRechazo = [],
  motivoAnulacionSeller,
  goToOrdenes
}) {
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [isFetching, setIsFetching] = useState(false);

  const postAnulacion = (buttonId) => {
    const request = {
      idVenta: idOrden,
      anularConDevolucion: buttonId === 1,
      anularSinDevolucion: buttonId === 2,
      rechazado: buttonId === 3,
      idMotivoAnula: parseInt(motivoRechazo) || motivoAnulacionSeller.idMotivo,
      idSeller: idSeller
    }

    setIsFetching(true);

    let req = postAnulacionReversionOrdenApi(request);
    req.then(res => {
      toast.success("Estado de orden actualizado");
      goToOrdenes();
    }).catch(err => {
      toast.warning("No se pudo actualizar el estado de la orden");
    }).finally(() => {
      setIsFetching(false);
    });
  };

  const isValidRechazo = (buttonId) => {
    if (buttonId !== 3) {
      if (!motivoAnulacionSeller?.idMotivo) {
        toast.warn("La solicitud de anulacion no tiene motivo");
        return false;
      }
    } else {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return false;
      }
    }
    return true;
  };

  return (
    <div className="row mb-3">

      <div className="col-12 col-sm-auto">
        {[
          { id: 1, label: "Anular con devolución" },
          { id: 2, label: "Anular sin devolución" },
          { id: 3, label: "Rechazar anulación" }
        ].map((button) => {
          return (
            <ModalItem
              key={button.id}
              disabled={isFetching}
              text={`¿Desea ${button.label.toLowerCase()}?`}
              onDelete={() => postAnulacion(button.id)}
              validationHandler={() => isValidRechazo(button.id)}
              btnStyle="btn btn-sm background-rojo-megatone col-12 col-sm-auto me-3"
              btnText={button.label}
            />
          )
        })}
      </div>

      <div className="form-group col-12 col-sm-4 col-md-5">
        <label>Motivo de rechazo</label>
        <select
          className="form-control"
          value={motivoRechazo}
          onChange={(e) => setMotivoRechazo(e.target.value)}
        >
          <option value=""></option>
          {motivosRechazo?.map((motivo, index) => (
            <option key={index} value={motivo.codigo}>{motivo.descripcion}</option>
          ))}
        </select>
      </div>

    </div>
  )
}